// A provider answering 402 — and whose wallet that is actually about.
//
// DeepSeek's exact words are "Insufficient Balance". Printed on the card, a
// user reads them as their own bill: «Мне нужно как-то оплатить работу в
// приложении, или это внутренняя ошибка?» (2026-09-03, an install that got
// eleven of them in a row on the default model). Through our gateway the
// account is ours: the gateway holds the credential, the user has no balance
// with the provider and nothing to top up. The honest sentence is the
// opposite of what the upstream said — nothing to pay, the outage is on our
// side, try again or pick another model.
//
// Keyed on the request URL, not the provider id, for the same reason as the
// not-found card beside this: `deepseek` is our route for most installs and a
// direct BYOK connection for others, and a BYOK user whose OWN DeepSeek
// account is empty must keep the upstream's words — for them "Insufficient
// Balance" is exactly right and the fix really is to pay.
//
// Only requests that went to OUR gateway qualify. The not-found card also
// treats GigaChat's fixed host as "not the user's endpoint", and for a wrong
// model id that is right — but billing is a different question. GigaChat is
// reached at gigachat.sberdevices.ru on BOTH routes (the rewrite to our proxy
// happens inside the SDK's fetch), so a Sber refusal carries no trace of whose
// credentials it refused: a BYOK GigaChat account with an exhausted token
// pack looks byte-for-byte like ours, and telling that user "nothing to pay"
// would be the same inverted advice this card exists to remove.

import { GATEWAY_HOST } from "./session-turn-model-not-found"

/**
 * Is this failure our own upstream account being refused over billing?
 * 402 is unambiguous on the provider we broker this way (DeepSeek says
 * Insufficient Balance, a reseller says insufficient credits); no body needed.
 */
export function brokeredBalanceRefused(input: { status?: unknown; url?: unknown; provider?: string }): boolean {
  if (input.status !== 402) return false
  if (typeof input.url !== "string") return false
  try {
    return GATEWAY_HOST.test(new URL(input.url).hostname)
  } catch {
    return false
  }
}
